import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicFreeToolsStarterCtaSubtext = ({
  selectedTerm
}) => {
  /* Always render so the card keeps the same height across term toggles.
   * Hide (rather than remove) the copy on annual to avoid layout shift. */
  return /*#__PURE__*/_jsx(View, {
    visibility: selectedTerm === 'MONTHLY' ? 'visible' : 'hidden',
    children: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.cta.noAnnualContract"
      })
    })
  });
};